<template>
	<v-data-table
		:headers="headers_local"
		:items="items_local"
		:hide-default-header="!$vuetify.breakpoint.smAndDown"
		:items-per-page="-1"
		hide-default-footer
		disable-sort
		:item-class="rowClass"
		@click:row="$emit('row-click', $event)"
	>
		<template v-if="!$vuetify.breakpoint.smAndDown" v-slot:header="{ props: { headers } }">
			<thead>
				<v-draggable v-model="headers_local" tag="tr">
					<th 
						v-for="item in headers" 
						:key="item.value" 
						class="header-th" 
						@mouseover="isHover = item.value"
						@mouseout="isHover = ''">
						<div class="header-item"
							v-if="item.showable"
							:style="(item.value === 'gross' || item.value === 'tax_amount' || item.value === 'amount' || item.value === 'value' || item.value === 'markup_perc' || item.value === 'markup_value') ? 'justify-content: flex-end':`${item.value === 'currency'? 'justify-content: center':''}`">
							<div v-if="item.type === 'option'">
								<v-checkbox
									color="info"
									:value="allSelect"
									:indeterminate="indeterminate"
									@change="onSelectAllChange($event)"
								></v-checkbox>
							</div>
							<div class="header-item-sub">
								<div class="header-item-text">{{ item.text }}</div>
								<SortUpDown 
									v-if="item.type === 'sort'" 
									class="icon icon-sort-up-down" 
									:selected="isHover === item.value" 
									:selected_color="color" 
									@click="onSort(item.value)"/>
							</div>
							<v-menu offset-y nudge-left="200" >
								<template v-slot:activator="{ on, attrs }">
									<div class="icon-wrap" v-bind="attrs" v-on="on">
										<ShowSearch 
											class="icon" 
											v-if="item.searchable" 
											:selected="isHover === item.value" 
											:selected_color="color"/>
									</div>
								</template>
								<div class="search-box">
									<v-text-field
										placeholder="Search Title..."
										outlined
										dense
										hide-details="auto"
										color="#00AAFD" 
										:value="current_key === item.value ? searchValue : ''"
										@input="searchValue = $event"
										@click.stop
									/>
									<div class="search-box-button">
										<div @click.stop="onClean">CLEAR</div>
										<div @click="onSearch(item.value)">SEARCH</div>
									</div>
								</div>
							</v-menu>
							<v-menu offset-y nudge-left="80" min-width="100px" :close-on-content-click="false">
								<template v-slot:activator="{ on, attrs }">
									<div class="icon-wrap" v-bind="attrs" v-on="on">
										<FirstList 
											v-if="item.type === 'filter'" 
											class="icon icon-sort-up-down" 
											:selected="isHover === item.value" 
											:selected_color="color"/>
									</div>
								</template>
								<div v-if="item.value === 'currency'">
									<div v-for="currency in currencies" :key="currency.id">
										<v-checkbox
											class="filter-box mt-0"
											v-model="select_currency"
											:label="currency.symbol"
											:value="currency.id"
											color="info"
											dense
											hide-details>
										</v-checkbox>
									</div>
								</div>
								<div v-if="item.value === 'tax_mode_desc'">
									<div v-for="tax in tax_settings" :key="tax.value">
										<v-checkbox
											class="filter-box mt-0"
											v-model="select_tax"
											:label="tax.text"
											:value="tax.value"
											color="info"
											dense
											hide-details>
										</v-checkbox>
									</div>
								</div>
							</v-menu>
						</div>
					</th>
				</v-draggable> 
			</thead>
		</template>
		<template v-slot:[`item.select`]="{ item }">		
			<v-checkbox
				v-model="item.select"
				@click.native.stop
				@change="onCheckboxChange()"
				color="info"
			></v-checkbox>	
		</template>
		<template v-slot:[`item.date`]="{ item }">			
			<span>{{ formatDate(item.date) }}</span>
		</template>
		<template v-slot:[`item.currency`]="{ item }">			
			<div v-html="item.currency.symbol" style="text-align: center;"></div>
		</template>
		<template v-slot:[`item.gross`]="{ item }">
			<span v-if="formatNumber(item.gross) === '0.00' && isFinance" class="amount-cell-value zero-amount-cell pr-2">{{ item.gross }}</span>
			<div v-if="formatNumber(item.gross) !== '0.00' && isFinance" style="text-align: right; margin-right: 15px">{{ formatNumber(item.gross) }}</div>
		</template>
		<template v-slot:[`item.value`]="{ item }">
			<div v-if="formatNumber(item.value) === '0.00' && !isFinance" class="red--text" style="text-align: right; margin-right: 15px">VALUE REQUIRED</div>
			<div v-if="formatNumber(item.value) !== '0.00' && !isFinance" style="text-align: right; margin-right: 15px">{{ formatNumber(item.value) }}</div>
		</template>
		<template v-slot:[`item.tax_amount`]="{ item }">			
			<div style="text-align: right; margin-right: 15px">{{ formatNumber(item.tax_amount) }}</div>
		</template>
		<template v-slot:[`item.amount`]="{ item }">			
			<div style="text-align: right; margin-right: 15px">{{ formatNumber(item.amount) }}</div>
		</template>
		<template v-slot:[`item.markup_perc`]="{ item }">			
			<div style="text-align: right; margin-right: 15px">{{ formatNumber(item.markup_perc) }} %</div>
		</template>
		<template v-slot:[`item.markup_value`]="{ item }">	
			<div style="text-align: right; margin-right: 15px">{{ formatNumber(item.markup_value) }}</div>			
		</template>
		<template v-slot:[`item.kind`]="{ item }">
			<span v-if="!item.kind" class="red--text">KIND REQUIRED</span>		
			<span v-if="item.kind && !isValidation" v-html="item.kind && item.kind.display_name"></span>	
			<span v-if="item.kind && isValidation" :class="validateKind(item.code, item.kind) ? '': 'red--text'" v-html="item.kind && item.kind.display_name"></span>	
		</template>
		<template v-slot:[`item.code`]="{ item }">
			<span v-if="!item.code" class="red--text">JOB REQUIRED</span>
			<span v-else v-html="item.code && item.code.code"></span>
		</template>
		<template v-slot:[`item.title`]="{ item }">
			<span v-if="!item.title" class="red--text">JOB REQUIRED</span>
			<span v-html="item.title && item.title.display_name"></span>
		</template>
		<template v-slot:[`item.phase`]="{ item }">
			<span v-if="!item.phase" class="red--text">PHASE REQUIRED</span>
			<span v-html="item.phase && item.phase.display_name"></span>
		</template>
		<template v-slot:[`item.thumbnail`]="{ item }">	
			<File 
				v-if="isFile && image_type.includes(item.image_type)"
				width="24" 
				hight="24" 
				:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'"
				:class="isFileView ? 'file-hover':''" 
				@click="onShowFile(item)" />
			<PDF
				v-if="isFile && item.image_type === pdf_type" 
				width="24" 
				hight="24"
				:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'"
				:class="isFileView ? 'file-hover':''" 
				@click="onShowFile(item)" />
		</template>
		<template v-if="!$vuetify.breakpoint.smAndDown" v-slot:[`body.append`]="">
			<tr v-if="isFooter && header[0].type === 'option'" class="table-footer">
				<td></td>
				<td>Total</td>
				<td>
					<div style="text-align: center;">{{ symbol }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">	{{ gross }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">{{ tax }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">{{ amount }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">--</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">{{ markup }}</div>
				</td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td v-if="isFile"></td>
			</tr>
			<tr v-if="isFooter && header[0].type !== 'option'" class="table-footer">
				<td>Total</td>
				<td>
					<div style="text-align: center;">{{ symbol }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">	{{ gross }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">{{ tax }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">	{{ amount }}</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">--</div>
				</td>
				<td>
					<div style="text-align: right; margin-right: 15px">{{ markup }}</div>
				</td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td></td>
				<td v-if="isFile"></td>
			</tr>
		</template>
	</v-data-table>
</template>
<script>
import SortUpDown from '@/components/icons/sort_up_down';
import ShowSearch from '@/components/icons/show_search';
import FirstList from "@/components/icons/first_list";
import File from '@/components/icons/attached_file_image';
import PDF from '@/components/icons/attached_file_pdf';

import config from "@/config.js";
import moment from 'moment';

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const FONT_COLOR = config.font_color;
const PAGE_INIT = 0;
const SCALE = 1.2;
const IMAGE_TYPE = ['image/jpeg','image/png'];
const PDF_TYPE = 'application/pdf';
const Max_Distance_Mobile = 48;
const Max_Distance_Window = 68;


export default {
	name: 'TableAttachedReceipt',
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		header: {
			type: Array,
			default: () => []
		},
		items: {
			type: Array,
			default: () => []
		},
		print: {
			type: Boolean,
			default: false
		},
		isFooter: {
			type: Boolean,
			default: true
		},
		isFile: {
			type: Boolean,
			default: false
		},
		symbol: {
			type: String,
			default: ""
		},
		amount: {
			type: String,
			default: ""
		},
		gross: {
			type: String,
			default: ""
		},
		tax: {
			type: String,
			default: ""
		},
		markup: {
			type: String,
			default: ""
		},
		tax_settings: {
			type: Array,
			default: () => [],
		},
		isValidation: {
			type: Boolean,
			default: false
		},
		isFileView: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			headers_local: this.header,
			items_local: [],
			items_local_original: [],
			searchValue: '',
			sortByAscent: false,
			isHover: '',
			current_key: '',
			select_currency: this.currencies.map(currency => { return currency.id }),
			select_tax: this.tax_settings.map(tax => { return tax.value }),
			isFinance: this.header.some(h => { return h.value === 'gross'}),
			image_type: IMAGE_TYPE,
			pdf_type: PDF_TYPE
		}
	},
	components: {
		SortUpDown, 
		ShowSearch,
		FirstList,
		File,
		PDF
	},
	created() {
		this.headers_local = this.header;
		this.items_local = this.items;
		this.items_local_original = this.items;
	},
	watch: {
		select_currency() {
			this.items_local = this.items_local_original.filter(item => {
				return this.select_currency.includes(item.currency.id);
			});
		},
		select_tax() {
			this.items_local = this.items_local_original.filter(item => {
				return this.select_tax.includes(item.tax_mode_code);
			});
		},
		header() {
			this.headers_local = this.header;
		},
		items() {
			this.items_local = this.items;
			this.items_local_original = this.items;
			const isSelected = this.items_local.some(item => { return item.select === true});
			if (!isSelected) {
				this.$emit('selected', isSelected);
			}
		}
	},
	computed: {
		indeterminate() {
			return this.items_local.length !== 0 
				&& !this.items_local.every(item => {return item.select === true})
				&& this.items_local.some(item => { return item.select === true});
		},
		allSelect() {
			return this.items_local.length !== 0 &&
				this.items_local.every(item => { return item.select === true});
		},
	},
	methods: {
		rowClass(item) {
			const classes = [];

			if (item.is_new_split) {
				classes.push('split-expense-row');
			}

			const arr = this.headers_local.filter(h => { return h.value === 'select'});
			if (arr.length !== 0 && !item.select && !print) {
				classes.push('d-print-none');
			}

			return classes.join(' ');
		},
		onCheckboxChange() {
			const selected = this.items_local.some(item => { return item.select === true});
			this.$emit('selected', selected);
		},
		onSelectAllChange(value) {
			if (value) {
				this.items_local.forEach(item => {
					item.select = true;
				});
			} else {
				this.items_local.forEach(item => {
					item.select = false;
				});
			}

			const selected = this.items_local.some(item => { return item.select === true});
			this.$emit('selected', selected);
		},
		getBlobDate(url) {
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					},
					responseType: 'blob',
				})
				.then((val) => {
					const { status, data } = val;
					if (status === 200) {
						const reader = new FileReader();
						reader.readAsDataURL(data); 
						reader.onload = readerEvent =>  {
							const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
							loadingTask.promise.then(pdf => {
								const preview_url = [];
								let page_total = pdf.numPages;

								for (let index = 0; index < pdf.numPages; index++) {
									pdf.getPage(index + 1).then(page => {
										const scale = SCALE;
										const viewport = page.getViewport({scale: scale});

										const canvas = document.createElement('canvas');
										const context = canvas.getContext('2d');
										canvas.width = viewport.width;
										canvas.height = viewport.height;

										const renderContext = {
											canvasContext: context,
											viewport: viewport
										};

										const renderTask = page.render(renderContext);
										renderTask.promise.then(() => {
											canvas.toBlob(blob => {
												const preview_item_url = URL.createObjectURL(blob);
												preview_url.push(preview_item_url);
												page_total -= 1;

												if (page_total === PAGE_INIT) {
													let image_width = 0;
													let image_height = 0;

													const isMobile = window.innerWidth < 600
													if (isMobile) {
														/** this.$vuetify.breakpoint.width <= 600 */
														const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
														image_width = max_width;
														image_height = max_width * (viewport.height / viewport.width);

													} else {
														/** this.$vuetify.breakpoint.width >= 960 */
														const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
														image_width = max_height * (viewport.width / viewport.height);
														image_height = max_height;
													}
													const show_image = {
														image: preview_url,
														image_width: image_width,
														image_height: image_height,
														url: url
													};
													this.$emit('show-file', show_image);
												}
											});									
										});
									});
								}
							});
						};
					}
				})
				.catch((e) => {
					this.$emit('error-msg', e.message);
				});
		},
		formatDate(date) {
			if(!date) return null;
			return moment(date).format('DD MMM YYYY');
		},
		formatNumber(value) {
			// from nmber to string, 12345.00 -> 12,345.00
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		validateKind(job, kind) {
			let validation = true;
			if (job) {
				if (kind && kind.overhead_mode === 1 && !job.is_overhead) {
					validation = false;
				}
				if (kind && kind.overhead_mode === 0 && kind.show_over === 0 && job.is_overhead) {
					validation = false;
				}
			}

			return validation;
		},
		onShowFile(item) {
			if (!this.isFileView) return;

			if (item.image_type === 'application/pdf') {
				this.getBlobDate(item.image);
			} else {
				const index = item.thumbnail.lastIndexOf('/');
				const image = item.thumbnail.slice(0, index + 1) + 'image';

				let image_width = 0;
				let image_height = 0;

				const my_image = new Image();
				my_image.src = image;
				my_image.onload = () => {
					if (this.$vuetify.breakpoint.smAndUp) {
						const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
						image_width = max_height * (my_image.width / my_image.height);
						image_height = max_height;
					} else {
						/* 48 = padding-left-24px + padding-right-24px */
						const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
						image_width = max_width;
						image_height = max_width * (my_image.height / my_image.width);
					}

					const show_image = {
						image: [image],
						image_width: image_width,
						image_height: image_height,
						url: image
					}

					this.$emit('show-file', show_image);
				}
			}
		},
		onSearch(key) {
			if (this.searchValue.length === 0) return;

			this.current_key = key;
				
			const arr_filter = this._filterKey(this.items_local_original, key, this.searchValue);
			const arr_replace = JSON.parse(JSON.stringify(arr_filter));

			// to hightlight the kewwords
			const regex = new RegExp(this.searchValue, 'gi');
			arr_replace.forEach(arr => {
				if (arr[key]) {
					if (key === 'code') {
						arr[key].code = arr[key].code.replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
					} else {
						if ( typeof(arr[key]) === 'object' ) {
							arr[key].display_name = arr[key].display_name.replace(regex, (keyword) => {
								return `<font color="${FONT_COLOR}">${keyword}</font>`;
							});
						} else {
							arr[key] = arr[key].replace(regex, (keyword) => {
								return `<font color="${FONT_COLOR}">${keyword}</font>`;
							});
						}
					}
				}
			});
			this.items_local = arr_replace;
		},
		onClean() {
			this.searchValue = '';
			this.items_local = this.items_local_original;
		},
		onSort(key) {
			this.sortByAscent = !this.sortByAscent;

			if (key === 'value' || key === 'gross' || key === 'tax_amount' || key === 'amount') {
				this.sortByAscent
					? this._sort_ascent_number(this.items_local, key)
					: this._sort_descent_number(this.items_local, key);
			} else {
				this.sortByAscent
					? this._sort_ascent(this.items_local, key)
					: this._sort_descent(this.items_local, key);
			}	
		},
		_sort_ascent(arr, key) {
			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';
				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				}

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA < valueB) {
					return -1;
				}
				if (valueA > valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_descent(arr, key) {
			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';

				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				} 

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA > valueB) {
					return -1;
				}
				if (valueA < valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_ascent_number(arr, key) {
			arr.sort((a, b) => {
				return a[key] - b[key];
			});
		},
		_sort_descent_number(arr, key) {
			arr.sort((a, b) => {
				return b[key] - a[key];
			});
		},
		_filterKey(arr, key, filter) {
			let fliter_Arr = [];
			const filter_UpperCase = filter.toUpperCase();
			fliter_Arr = arr.filter(a => {
				let A = '';
				if (a[key]) {
					if (key === 'code') {
						A = typeof(a[key]) === 'object' ? a[key].code.toUpperCase() : a[key].toUpperCase();
					} else {
						A = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
					}
				} 
				return A.includes(filter_UpperCase);
			});
			
			return fliter_Arr;
		},
	}
}

</script>
<style lang="scss" scoped>
::v-deep {
	tbody tr.split-expense-row,
	tbody tr.split-expense-row:hover {
		background-color: #FBF7F0 !important;
	}
}

.table-head {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	height: 48px;
	padding: 0 20px;
	background: #FAFAFA;
	color: #192A3E;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	border-bottom: 1px solid #C9C9C9;
	border-radius: 4px 4px 0 0;
	span {
		font-weight: bold;
	}
}
.header-th {
	background: #FAFAFA;
	border-top: 1px solid #C9C9C9;
	&:hover {
		background: #EAEAEA;
		cursor: move;
	}
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-item-sub {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
}
.header-th:hover .icon {
	visibility: visible; 
}
.header-item-text {
	white-space: nowrap;
	text-overflow: ellipsis;
}
.icon-wrap {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.icon {
	visibility: hidden;
	width: 14px;
  height: 14px;
	&:hover {
		cursor: pointer;
	}
}
.icon-sort-up-down {
  margin-left: 6px;
}
.search-box {
	padding: 13px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #FFFFFF;
	border-radius: 4px;
	.search-box-button {
		margin-top: 9px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		div {
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			padding: 0 21px;

			font-family: Roboto;
			font-style: normal;
			font-weight: 500;
			font-size: 14px;
			height: 36px;

			&:hover {
				cursor: pointer;
			}
		}
		:first-child {
			border: 1px solid rgba(25, 42, 62, 0.7);
			margin-right: 10px;
			color: rgba(25, 42, 62, 0.7);
		}
		:last-child {
			border: 1px solid #00AAFD;
			background: #00AAFD;
			color: #FFFFFF;
		}
	}
}
.filter-box {
	background: #FFFFFF;
}
.text-able {
	color: rgba(0, 0, 0, 0.87);
}
.text-disable {
	color: #C4C4C4;
}
.table-footer {
	width: 100%;
	height: 68px;
	margin-left: 0;
	background: #FAFAFA;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.87);
}
.file-hover {
	&:hover {
		cursor: pointer;
	}
}
.amount-cell-value {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 32px;
	margin: 0 4px;
}
.amount-cell-value.zero-amount-cell {
	border: 2px solid #F45252;
	border-radius: 4px;
}
</style>
